<template>
  <div>
    <!-- <b-loading :active.sync="isLoadingPage"></b-loading> -->
    <transition name="slide-fade">
      <div class="loading-integreat" v-if="isLoadingPage">
        <div class="initial-load-animation">
          <div class="linkedin-image"></div>
          <div class="loading-bar">
            <div class="blue-bar"></div>
          </div>
        </div>
      </div>
    </transition>
    <div class="level is-margin-bottom-2 is-hidden-mobile">
      <div class="level-left">
        <p class="title is-4 is-spaced has-text-weight-normal label-Left">
          {{ $t("staffList.staffListHeader") }} ({{ staffLists.length }}
          {{
            staffLists.length > 1
              ? $t("message.staffsSuffix")
              : $t("message.staffSuffix")
          }})
        </p>
      </div>
      <div class="level-right">
        <b-dropdown ref="dropdowntablet" position="is-bottom-left">
          <button class="button btn-Filter" slot="trigger">
            <span class="icon is-small">
              <i class="fa fa-filter"></i>
            </span>
            <span>{{ $t("message.btnFilter") }}</span>
          </button>
          <b-dropdown-item custom paddingless>
            <div class="modal-card mx-not modal-search">
              <section class="modal-card-body contentSearch">
                <div class="headerFilter">
                  <span class="icon is-small is-size-5">
                    <i class="fa fa-filter"></i>
                  </span>
                  <span
                    class="is-padding-sm-x is-size-5 has-text-weight-normal"
                    >{{ $t("message.btnFilter") }}</span
                  >
                </div>

                <b-field grouped>
                  <b-input
                    class="is-medium"
                    type="search"
                    icon-pack="fas"
                    icon="search"
                    v-model="searchName"
                    :placeholder="$t('staffList.staffDetailName')"
                    expanded
                  ></b-input>
                </b-field>

                <b-field grouped>
                  <b-input
                    class="is-medium"
                    type="search"
                    icon-pack="fas"
                    icon="search"
                    v-model="searchLastName"
                    :placeholder="$t('staffList.staffDetailLastname')"
                    expanded
                  ></b-input>
                </b-field>

                <b-field grouped>
                  <b-input
                    class="is-medium"
                    type="search"
                    icon-pack="fas"
                    icon="search"
                    v-model="searchTel"
                    :placeholder="$t('staffList.staffDetailTelephone')"
                    expanded
                  ></b-input>
                </b-field>

                <b-field grouped>
                  <b-input
                    class="is-medium"
                    type="search"
                    icon-pack="fas"
                    icon="search"
                    v-model="searchEmail"
                    :placeholder="$t('staffList.staffDetailEmail')"
                    expanded
                  ></b-input>
                </b-field>
                <b-field grouped>
                  <div class="control is-expanded level">
                    <div class="search-btn">
                      <button class="button btnSearch" @click="filter()">
                        {{ $t("message.btnSearch") }}
                      </button>
                    </div>
                    <div class="reset-btn">
                      <button @click="resetFilter()" class="button btnReset th">
                        {{ $t("message.btnReset") }}
                      </button>
                    </div>
                  </div>
                </b-field>
              </section>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <div
      class="is-flex is-justify-spacebetween is-align-center is-hidden-tablet"
    >
      <div>
        <p
          class="title is-size-6-5 is-spaced has-text-weight-normal label-Left"
        >
          {{ $t("staffList.staffListHeader") }} ({{ staffLists.length }}
          {{
            staffLists.length > 1
              ? $t("message.staffsSuffix")
              : $t("message.staffSuffix")
          }})
        </p>
      </div>
      <div>
        <b-dropdown ref="dropdownmobile" position="is-bottom-left">
          <button class="button btn-Filter-mobile" slot="trigger">
            <span class="icon is-small">
              <i class="fa fa-filter"></i>
            </span>
            <span>{{ $t("message.btnFilter") }}</span>
          </button>
          <b-dropdown-item custom paddingless>
            <div class="modal-card mx-not modal-search">
              <section class="modal-card-body contentSearch">
                <div class="headerFilter">
                  <span class="icon is-small is-size-5">
                    <i class="fa fa-filter"></i>
                  </span>
                  <span
                    class="is-padding-sm-x is-size-5 has-text-weight-normal"
                    >{{ $t("message.btnFilter") }}</span
                  >
                </div>

                <b-field grouped>
                  <b-input
                    class="is-medium"
                    type="search"
                    icon-pack="fas"
                    icon="search"
                    v-model="searchName"
                    :placeholder="$t('staffList.staffDetailName')"
                    expanded
                  ></b-input>
                </b-field>

                <b-field grouped>
                  <b-input
                    class="is-medium"
                    type="search"
                    icon-pack="fas"
                    icon="search"
                    v-model="searchLastName"
                    :placeholder="$t('staffList.staffDetailLastname')"
                    expanded
                  ></b-input>
                </b-field>

                <b-field grouped>
                  <b-input
                    class="is-medium"
                    type="search"
                    icon-pack="fas"
                    icon="search"
                    v-model="searchTel"
                    :placeholder="$t('staffList.staffDetailTelephone')"
                    expanded
                  ></b-input>
                </b-field>

                <b-field grouped>
                  <b-input
                    class="is-medium"
                    type="search"
                    icon-pack="fas"
                    icon="search"
                    v-model="searchEmail"
                    :placeholder="$t('staffList.staffDetailEmail')"
                    expanded
                  ></b-input>
                </b-field>
                <b-field grouped>
                  <div class="control is-expanded level">
                    <div class="search-btn">
                      <button class="button btnSearch" @click="filter()">
                        {{ $t("message.btnSearch") }}
                      </button>
                    </div>
                    <div class="reset-btn">
                      <button @click="resetFilter()" class="button btnReset th">
                        {{ $t("message.btnReset") }}
                      </button>
                    </div>
                  </div>
                </b-field>
              </section>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <div class="columns is-margin-x-not head-table is-hidden-mobile">
      <div class="column is-3 has-text-centered" @click="sortBy('name')">
        <p
          class="is-size-7 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'name' }"
        >
          {{ $t("staffList.staffName") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'name'"
          ></span>
        </p>
      </div>
      <div class="column has-text-centered" @click="sortBy('mobilePhone')">
        <p
          class="is-size-7 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'mobilePhone' }"
        >
          {{ $t("staffList.staffPhone") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'mobilePhone'"
          ></span>
        </p>
      </div>
      <div class="column has-text-centered" @click="sortBy('email')">
        <p
          class="is-size-7 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'email' }"
        >
          {{ $t("staffList.staffEmail") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'email'"
          ></span>
        </p>
      </div>
      <div class="column has-text-centered" @click="sortBy('countStartUp')">
        <p
          class="is-size-7 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'countStartUp' }"
        >
          {{ $t("staffList.staffNo") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'countStartUp'"
          ></span>
        </p>
      </div>
      <div class="column has-text-centered" @click="sortBy('updatedAt')">
        <p
          class="is-size-7 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'updatedAt' }"
        >
          {{ $t("staffList.staffLastUpdated") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'updatedAt'"
          ></span>
        </p>
      </div>
      <div class="column is-1 has-text-centered"></div>
    </div>
    <div
      v-if="staffLists == '' || staffLists == null"
      class="is-detail-list detail-table mg-y-15"
    >
      <p class="has-text-drak is-size-4 th is-padding-x-s is-margin-top-s">
        ***
      </p>
      <p class="has-text-drak is-size-6 th is-padding-x has-text-centered">
        {{ $t("staffList.notFound") }}
      </p>
      <p class="has-text-drak is-size-4 th is-padding-x-s is-margin-top-s">
        ***
      </p>
    </div>
    <div
      v-else
      class="columns detail-table is-margin-x-not is-vcentered"
      v-for="(data, index) in staffLists"
      :key="index"
    >
      <div class="column is-1 has-text-right dp-menu-action is-hidden-tablet">
        <b-dropdown position="is-bottom-left">
          <button class="button dp-btn-noBg" slot="trigger">
            <template>
              <b-tooltip
                label="More"
                position="is-bottom"
                type="is-white"
                :delay="500"
              >
                <b-icon
                  pack="fas"
                  icon="sync-alt"
                  custom-class="fa-ellipsis-v label-right"
                  class="has-text-grey-light pd-20"
                ></b-icon>
              </b-tooltip>
            </template>
          </button>
          <b-dropdown-item
            @click="selectStaff(data.staffId, 'dashboard')"
            class="is-align-center is-justify-center is-flex-medium is-flex-row dp-item-board"
          >
            <div class="has-text-white">
              <p class="textActive">
                {{ $t("staffList.staffMoreButtonDashboard") }}
              </p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item
            @click="selectStaff(data.staffId, '')"
            class="is-align-center is-justify-center is-flex-medium is-margin-top-s is-flex-row dp-item-view"
          >
            <div class="has-text-white">
              <p class="textActive">
                {{ $t("staffList.staffMoreButtonCompany") }}
              </p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item
            @click="modalDelete(index, data)"
            class="is-align-center is-justify-center is-flex-medium is-flex-row is-margin-top-s dp-item-delete"
          >
            <p class="has-text-white">
              {{ $t("staffList.staffMoreButtonDelete") }}
            </p>
          </b-dropdown-item>
        </b-dropdown>
      </div>

      <div class="column is-3" data-label="name">
        <div
          v-if="widthMax > 768"
          class="is-align-center is-justify-center is-flex-large is-flex-row is-hidden-mobile"
        >
          <div class="column is-2 has-text-right icon-unflex">
            <div v-show="data.userStatus === 0">
              <b-tooltip
                label="Unverified"
                size="is-small"
                class="mg-l-5"
                type="is-dark"
              >
                <b-icon
                  pack="fas"
                  icon="exclamation-circle"
                  custom-class="exclamation-circle"
                  class="has-color-light-bold"
                ></b-icon>
              </b-tooltip>
            </div>
            <div v-show="data.userStatus === 1">
              <b-tooltip
                label="Wait for Approval"
                size="is-small"
                class="mg-l-5"
                type="is-dark"
              >
                <b-icon
                  pack="fas"
                  icon="exclamation-circle"
                  custom-class="exclamation-circle"
                  class="has-text-warning-yellow"
                ></b-icon>
              </b-tooltip>
            </div>
            <div v-show="data.userStatus === 2">
              <b-tooltip
                label="Verified"
                size="is-small"
                class="mg-l-5"
                type="is-dark"
              >
                <b-icon
                  pack="fas"
                  icon="check-circle"
                  custom-class="check-circle"
                  class="has-text-primary"
                ></b-icon>
              </b-tooltip>
            </div>
            <div v-show="data.userStatus === 3">
              <b-tooltip
                label="Suspended"
                size="is-small"
                class="mg-l-5"
                type="is-dark"
              >
                <b-icon
                  pack="fas"
                  icon="ban"
                  custom-class="ban"
                  class="has-text-danger-status"
                ></b-icon>
              </b-tooltip>
            </div>
          </div>
          <div
            class="column is-3 is-2-fullhd has-text-centered-tablet has-text-right"
          >
            <figure class="image box-circle-s is-marginless">
              <img
                class="is-rounded"
                @error="
                  $event.target.src =
                    'https://bulma.io/images/placeholders/64x64.png'
                "
                v-if="checkimg(imgUrl, data.profilePic)"
                :src="imgUrl + data.profilePic"
              />
              <img
                class="is-rounded"
                v-else
                src="https://bulma.io/images/placeholders/64x64.png"
                alt="Placeholder image"
              />
            </figure>
          </div>
          <div class="column has-text-left">
            <p class="is-size-6 th">{{ data.name }} {{ data.surname }}</p>
          </div>
        </div>
        <div
          v-if="widthMax < 768"
          class="is-align-center is-justify-center is-flex is-flex-column is-hidden-tablet"
        >
          <div class="column is-5 has-text-centered pd-col-fixed">
            <figure class="image box-circle-s">
              <img
                class="is-rounded"
                @error="
                  $event.target.src =
                    'https://bulma.io/images/placeholders/64x64.png'
                "
                v-if="checkimg(imgUrl, data.profilePic)"
                :src="imgUrl + data.profilePic"
              />
              <img
                class="is-rounded"
                v-else
                src="https://bulma.io/images/placeholders/64x64.png"
                alt="Placeholder image"
              />
            </figure>
          </div>
          <div class="column is-7 has-text-centered pd-col-fixed">
            <p class="is-size-6 th">{{ data.name }} {{ data.surname }}</p>
          </div>
        </div>
      </div>
      <div class="column has-text-centered" data-label="mobilePhone">
        <p class="is-size-6 has-text-weight-normal">{{ data.mobilePhone }}</p>
      </div>
      <div class="column has-text-centered" data-label="email">
        <p class="is-size-6 has-text-weight-normal">{{ data.email }}</p>
      </div>
      <div class="column has-text-centered" data-label="countStartUp">
        <p class="is-size-6 has-text-weight-normal">{{ data.countStartUp }}</p>
      </div>
      <div class="column has-text-centered" data-label="updatedAt">
        <p class="is-size-6 has-text-weight-normal">
          {{ dateFomat(data.updatedAt) }}
        </p>
      </div>
      <div class="column is-1 has-text-right dp-menu-action is-hidden-mobile">
        <b-dropdown position="is-bottom-left">
          <button class="button dp-btn-noBg" slot="trigger">
            <template>
              <b-tooltip
                label="More"
                position="is-bottom"
                type="is-white"
                :delay="500"
              >
                <b-icon
                  pack="fas"
                  icon="sync-alt"
                  custom-class="fa-ellipsis-v label-right"
                  class="has-text-grey-light is-margin-right-m"
                ></b-icon>
              </b-tooltip>
            </template>
          </button>
          <b-dropdown-item
            @click="selectStaff(data.staffId, 'dashboard')"
            class="is-align-center is-justify-center is-flex-medium is-flex-row dp-item-board"
          >
            <div class="has-text-white">
              <p class="textActive">
                {{ $t("staffList.staffMoreButtonDashboard") }}
              </p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item
            @click="selectStaff(data.staffId, '')"
            class="is-align-center is-justify-center is-flex-medium is-margin-top-s is-flex-row dp-item-view"
          >
            <div class="has-text-white">
              <p class="textActive">
                {{ $t("staffList.staffMoreButtonCompany") }}
              </p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item
            @click="modalDelete(index, data)"
            class="is-align-center is-justify-center is-flex-medium is-flex-row is-margin-top-s dp-item-delete"
          >
            <p class="has-text-white">
              {{ $t("staffList.staffMoreButtonDelete") }}
            </p>
          </b-dropdown-item>
        </b-dropdown>
      </div>

      <div class="pd-20 is-hidden-tablet"></div>
    </div>

    <b-modal :active.sync="isDeleteStaff" :width="900" @close="closeModal()">
      <div class="card modalActivity is-padding-y">
        <div class="card-content">
          <div class="content">
            <div
              class="is-align-center is-justify-center is-flex-medium is-flex-column"
            >
              <p
                v-if="countStartUp == 0 && $i18n.locale === 'th'"
                class="is-size-5 label-center th"
              >
                คุณต้องการลบ
                <a>{{ delStaffName }}</a> หรือไม่?
              </p>
              <p
                v-if="countStartUp == 0 && $i18n.locale === 'en'"
                class="is-size-5 label-center th"
              >
                Do you want to remove
                <a>{{ delStaffName }}</a
                >?
              </p>

              <p v-if="countStartUp == 0" class="is-size-5 label-center th">
                ({{ $t("message.alertDeleteDescription") }})
              </p>
              <p
                v-if="countStartUp != 0"
                class="is-size-5 confirm-padding-left"
              >
                {{ $t("staffList.alertDeleteStaff") }}
              </p>
            </div>
            <div
              class="is-align-center is-justify-center is-flex-medium is-flex-row"
            >
              <button
                class="button btn-delete is-margin-left"
                slot="trigger"
                @click="deleteUser(staffLists[idSelect].staffId)"
                v-if="countStartUp == 0"
              >
                <span class="text-modal ff-fix">{{
                  $t("message.btnYes")
                }}</span>
              </button>
              <button
                class="button btn-delete is-margin-left"
                slot="trigger"
                @click="
                  [
                    (isDeleteStaff = false),
                    $store.commit('setModalActive', false),
                  ]
                "
              >
                <span class="text-modal ff-fix" v-if="countStartUp == 0">{{
                  $t("message.btnNo")
                }}</span>
                <span class="text-modal ff-fix" v-else>{{
                  $t("message.btnYes")
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { HTTP } from "../axios.js";

export default {
  data() {
    return {
      widthMax: window.innerWidth,
      isDeleteStaff: false,
      staffLists: [],
      imgUrl: process.env.VUE_APP_IMAGE_URL,
      idSelect: 0,
      delStaffName: "",
      countStartUp: 0,
      searchName: null,
      searchLastName: null,
      searchTel: null,
      searchEmail: null,
      allList: [],
      isLoadingPage: null,
      currentSort: "",
      currentSortDir: "asc",
      isConnected: false,
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    this.isLoadingPage = true;
  },
  computed: {
    batch() {
      return this.$store.state.batch;
    },
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
  },
  sockets: {
    resListStaffInBatch(res) {
      if (res.success && res.obj.batchId === this.batch._id) {
        this.allList = res.obj.staffs;
        let staff = res.obj.staffs.sort((a, b) => {
          const modifier = -1;
          if (a.updatedAt < b.updatedAt) return -1 * modifier;
          if (a.updatedAt > b.updatedAt) return 1 * modifier;
          return 0;
        });
        this.staffLists = staff;
      }
    },
  },
  methods: {
    emitListStaffInBatch() {
      this.$socket.emit("listStaffInBatch", {
        batchId: this.batch._id,
      });
    },
    async checkimg(url, img) {
      let status = false;
      status = await HTTP.get(url + img).then((res) => {
        if (res.status == 200) {
          return true;
        }
      });
      return status;
    },
    sortBy(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;

      if (
        typeof this.staffLists === "undefined" ||
        this.staffLists === null ||
        this.staffLists.length === 0
      ) {
      } else {
        this.staffLists = this.staffLists.sort((a, b) => {
          let modifier = 1;
          if (this.currentSortDir === "desc") modifier = -1;
          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        });
      }
    },
    closeModal() {
      this.$store.commit("setModalActive", false);
    },
    resetFilter() {
      this.staffLists = this.allList;
      this.searchName = null;
      this.searchTel = null;
      this.searchEmail = null;
      this.searchLastName = null;
    },
    filter() {
      if (
        this.searchName == null &&
        this.searchTel == null &&
        this.searchEmail == null &&
        this.searchLastName == null
      ) {
        this.staffLists = this.allList;
      } else if (
        this.searchName != null &&
        this.searchTel == null &&
        this.searchEmail == null &&
        this.searchLastName == null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.name.toLowerCase().indexOf(this.searchName.toLowerCase()) >
            -1
        );
        //console.log("search1", this.staffLists);
      } else if (
        this.searchName != null &&
        this.searchTel != null &&
        this.searchEmail == null &&
        this.searchLastName == null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.name.toLowerCase().indexOf(this.searchName.toLowerCase()) >
              -1 &&
            search.mobilePhone
              .toLowerCase()
              .indexOf(this.searchTel.toLowerCase()) > -1
        );
        //console.log("search2", this.staffLists);
      } else if (
        this.searchName != null &&
        this.searchTel != null &&
        this.searchEmail != null &&
        this.searchLastName == null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.name.toLowerCase().indexOf(this.searchName.toLowerCase()) >
              -1 &&
            search.mobilePhone
              .toLowerCase()
              .indexOf(this.searchTel.toLowerCase()) > -1 &&
            search.email.toLowerCase().indexOf(this.searchEmail.toLowerCase()) >
              -1
        );
        //console.log("search3", this.staffLists);
      } else if (
        this.searchName != null &&
        this.searchTel == null &&
        this.searchEmail == null &&
        this.searchLastName != null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.name.toLowerCase().indexOf(this.searchName.toLowerCase()) >
              -1 &&
            search.surname
              .toLowerCase()
              .indexOf(this.searchLastName.toLowerCase()) > -1
        );
        //console.log("search4", this.staffLists);
      } else if (
        this.searchName != null &&
        this.searchTel != null &&
        this.searchEmail == null &&
        this.searchLastName != null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.name.toLowerCase().indexOf(this.searchName.toLowerCase()) >
              -1 &&
            search.mobilePhone
              .toLowerCase()
              .indexOf(this.searchTel.toLowerCase()) > -1 &&
            search.surname
              .toLowerCase()
              .indexOf(this.searchLastName.toLowerCase()) > -1
        );
        //console.log("search5", this.staffLists);
      } else if (
        this.searchName == null &&
        this.searchTel != null &&
        this.searchEmail != null &&
        this.searchLastName == null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.mobilePhone
              .toLowerCase()
              .indexOf(this.searchTel.toLowerCase()) > -1 &&
            search.email.toLowerCase().indexOf(this.searchEmail.toLowerCase()) >
              -1
        );
        //console.log("search6", this.staffLists);
      } else if (
        this.searchName == null &&
        this.searchTel != null &&
        this.searchEmail == null &&
        this.searchLastName != null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.mobilePhone
              .toLowerCase()
              .indexOf(this.searchTel.toLowerCase()) > -1 &&
            search.surname
              .toLowerCase()
              .indexOf(this.searchLastName.toLowerCase()) > -1
        );
      } else if (
        this.searchName != null &&
        this.searchTel != null &&
        this.searchEmail != null &&
        this.searchLastName != null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.name.toLowerCase().indexOf(this.searchName.toLowerCase()) >
              -1 &&
            search.mobilePhone
              .toLowerCase()
              .indexOf(this.searchTel.toLowerCase()) > -1 &&
            search.email.toLowerCase().indexOf(this.searchEmail.toLowerCase()) >
              -1 &&
            search.surname
              .toLowerCase()
              .indexOf(this.searchLastName.toLowerCase()) > -1
        );
        //console.log("search8", this.staffLists);
      } else if (
        this.searchName != null &&
        this.searchTel != null &&
        this.searchEmail != null &&
        this.searchLastName != null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.name.toLowerCase().indexOf(this.searchName.toLowerCase()) >
              -1 &&
            search.mobilePhone
              .toLowerCase()
              .indexOf(this.searchTel.toLowerCase()) > -1 &&
            search.email.toLowerCase().indexOf(this.searchEmail.toLowerCase()) >
              -1 &&
            search.surname
              .toLowerCase()
              .indexOf(this.searchLastName.toLowerCase()) > -1
        );
        //console.log("search9", this.staffLists);
      } else if (
        this.searchName == null &&
        this.searchTel != null &&
        this.searchEmail == null &&
        this.searchLastName == null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.mobilePhone
              .toLowerCase()
              .indexOf(this.searchTel.toLowerCase()) > -1
        );
        //console.log("search10", this.staffLists);
      } else if (
        this.searchName == null &&
        this.searchTel != null &&
        this.searchEmail != null &&
        this.searchLastName == null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.mobilePhone
              .toLowerCase()
              .indexOf(this.searchTel.toLowerCase()) > -1 &&
            search.email.toLowerCase().indexOf(this.searchEmail.toLowerCase()) >
              -1
        );
        //console.log("search11", this.staffLists);
      } else if (
        this.searchName == null &&
        this.searchTel != null &&
        this.searchEmail != null &&
        this.searchLastName != null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.email.toLowerCase().indexOf(this.searchEmail.toLowerCase()) >
              -1 &&
            search.surname
              .toLowerCase()
              .indexOf(this.searchLastName.toLowerCase()) > -1
        );
        //console.log("search12", this.staffLists);
      } else if (
        this.searchName == null &&
        this.searchTel == null &&
        this.searchEmail != null &&
        this.searchLastName == null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.email.toLowerCase().indexOf(this.searchEmail.toLowerCase()) >
            -1
        );
        //console.log("search13", this.staffLists);
      } else if (
        this.searchName == null &&
        this.searchTel == null &&
        this.searchEmail != null &&
        this.searchLastName != null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.email.toLowerCase().indexOf(this.searchEmail.toLowerCase()) >
              -1 &&
            search.surname
              .toLowerCase()
              .indexOf(this.searchLastName.toLowerCase()) > -1
        );
        //console.log("search14", this.staffLists);
      } else if (
        this.searchName == null &&
        this.searchTel == null &&
        this.searchEmail == null &&
        this.searchLastName != null
      ) {
        this.staffLists = this.allList.filter(
          (search) =>
            search.surname
              .toLowerCase()
              .indexOf(this.searchLastName.toLowerCase()) > -1
        );
        //console.log("search15", this.staffLists);
      }

      if (
        typeof this.$refs.dropdowntablet !== "undefined" &&
        typeof this.$refs.dropdownmobile !== "undefined"
      ) {
        this.$refs.dropdowntablet.isActive = false;
        this.$refs.dropdownmobile.isActive = false;
      }
    },
    async fetchData() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.get(`api/user/get/staff/on/batch/${this.batch._id}`)
        .then((res) => {
          //console.log('api/user/get/staff/on/batch', res);
          if (res.data.success) {
            let staff = res.data.obj.staffs.sort((a, b) => {
              const modifier = -1;
              if (a.registerDate < b.registerDate) return -1 * modifier;
              if (a.registerDate > b.registerDate) return 1 * modifier;
              return 0;
            });
            this.staffLists = staff;
            this.allList = staff;
            this.isLoadingPage = false;
          } else {
            this.staffLists = [];
            this.allList = [];
            this.isLoadingPage = false;
          }
        })
        .catch((e) => {
          this.isLoadingPage = false;
          console.log("api/user/get/staff/on/batch/error", e);
          alert("เครือขายไม่เสถียร กรุณาลองใหม่");
        });
    },
    modalDelete(value, data) {
      this.isDeleteStaff = true;
      this.idSelect = value;
      this.delStaffName = data.name;
      this.countStartUp = data.countStartUp;
      this.$store.commit("setModalActive", true);
    },
    async deleteUser(value) {
      this.isLoadingPage = true;
      const data = {
        staffId: value,
        token: this.token,
        batchId: this.batch._id,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${data.token}`;
      await HTTP.delete(
        `/api/user/delete/staff/${data.staffId}/from/batch/${data.batchId}`
      )
        .then((res) => {
          // console.log("/api/user/delete/staff/{staffId}/batch/{batchId}", res)
          if (res.data.success) {
            this.fetchData();
            this.emitRealTimeBoardNoti();
            this.emitListStaffInBatch();
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }

          this.idSelect = 0;
          this.isDeleteStaff = false;
          this.$store.commit("setModalActive", false);
          this.isLoadingPage = false;
        })
        .catch((e) => {
          console.log(
            "/api/user/delete/staff/{staffId}/batch/{batchId}/error",
            e
          );
          this.isLoadingPage = false;
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
    },
    emitRealTimeBoardNoti() {
      this.user.listBoards.map((item) => {
        this.$socket.emit("listNoti", {
          userId: item,
          batchId: "",
        });
      });
    },
    async selectStaff(value, page) {
      const data = {
        staffId: value,
        token: this.token,
        batchId: this.batch._id,
      };
      await this.$store.dispatch("setStaffDetail", data);
      if (page === "dashboard") {
        this.$router.push("/staff-detail-dashboard");
      } else {
        this.$router.push("/staff-detail");
      }
    },
    dateFomat(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "";
      } else {
        res = this.$moment(date).format("DD MMMM Y h:mm a");
      }
      return res;
    },
  },
  dateFomat(date) {
    let res = "";
    if (typeof date === "undefined" || date === null || date === "") {
      res = "";
    } else {
      res = this.$moment(date).format("DD MMMM Y h:mm a");
    }
    return res;
  },
};
</script>
/* eslint-disable */
<style>
@media screen and (max-width: 1280px) {
  .figureless {
    margin-left: 0.2rem !important;
  }
}
@media screen and (min-width: 1280px) {
  .figureless {
    margin-left: 1.5rem !important;
  }
}
.textDetailStaffUpList {
  font-size: 0.8rem;
}
#textNameBox {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}

.boxIconEllipsis {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}
.boxIconTrash {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}
svg:not(:root).svg-inline--fa {
  overflow: visible;
  margin: 0;
}
</style>
